//-----[石一覧からデータを取得]
var stoneAry = [];
$(".stone_list li").each(function (index, elm) {
  var name = $(elm).find(".name").text();
  var img = $(elm).find("img").attr("src");
  stoneAry.push({
    name: name,
    img: img,
  });
});

//-----[石（1粒目）変更時]
$(".select_stone1").change(function (e) {
  var no = e.currentTarget.selectedIndex - 1;
  if(no > -1) {
  $(".stone1").attr("src", stoneAry[no].img);
  } else {
  $(".stone1").attr( //シミュレーター画像内の石画像をリセット
    "src",
    "data:image/gif;base64,R0lGODlhAQABAGAAACH5BAEKAP8ALAAAAAABAAEAAAgEAP8FBAA7"
  );
  }
});

//-----[石（2粒目）変更時]
$(".select_stone2").change(function (e) {
  var no = e.currentTarget.selectedIndex - 1;
  if(no > -1) {
  $(".stone2").attr("src", stoneAry[no].img);
  } else {
  $(".stone2").attr( //シミュレーター画像内の石画像をリセット
    "src",
    "data:image/gif;base64,R0lGODlhAQABAGAAACH5BAEKAP8ALAAAAAABAAEAAAgEAP8FBAA7"
  );
  }
});

//-----[石（3粒目）変更時]
$(".select_stone3").change(function (e) {
  var no = e.currentTarget.selectedIndex - 1;
  if(no > -1) {
  $(".stone3").attr("src", stoneAry[no].img);
  } else {
  $(".stone3").attr( //シミュレーター画像内の石画像をリセット
    "src",
    "data:image/gif;base64,R0lGODlhAQABAGAAACH5BAEKAP8ALAAAAAABAAEAAAgEAP8FBAA7"
  );
  }
});

//-----[石（4粒目）変更時]
$(".select_stone4").change(function (e) {
  var no = e.currentTarget.selectedIndex - 1;
  if(no > -1) {
  $(".stone4").attr("src", stoneAry[no].img);
  } else {
  $(".stone4").attr( //シミュレーター画像内の石画像をリセット
    "src",
    "data:image/gif;base64,R0lGODlhAQABAGAAACH5BAEKAP8ALAAAAAABAAEAAAgEAP8FBAA7"
  );
  }
});

//-----[石（5粒目）変更時]
$(".select_stone5").change(function (e) {
  var no = e.currentTarget.selectedIndex - 1;
  if(no > -1) {
  $(".stone5").attr("src", stoneAry[no].img);
  } else {
  $(".stone5").attr( //シミュレーター画像内の石画像をリセット
    "src",
    "data:image/gif;base64,R0lGODlhAQABAGAAACH5BAEKAP8ALAAAAAABAAEAAAgEAP8FBAA7"
  );
  }
});

//-----[セレクトボックス変更時]
$("select").change(function (e) {
  var item_no = 1;
  var type_no = 1;

  $(".simulator_container select").each(function (index, elm) {
    if ($(elm).hasClass("select_item") === true) { //商品
      item_no = $(elm).val();
    } else if ($(elm).hasClass("select_type")) { //金種
      type_no = $(elm).val();
    }
  });

  //------[該当画像に差し替え]
  var defaultImage = '//cobaco.shop/cdn/shop/t/7/assets/simulate_birthstone_ring1_1.png?v=138387496711019963281695650322';
  var changeImage = defaultImage.replace('simulate_birthstone_ring1_1.png', 'simulate_birthstone_ring' + item_no + '_' + type_no + '.png');
  $(".base .ring").attr("src",changeImage);

  // $(".base .ring").attr(
  //   "src",
  //   "https://cobaco.shop/wp/wp-content/themes/cobaco/img/simulate_ring" +
  //     item_no +
  //     "_" +
  //     type_no +
  //     ".png"
  // );
});

//-----[アイテム変更時]
$(".select_item").change(function (e) {
  //-----[項目表示の初期化]
  $(".stones").attr( //シミュレーター画像内の石画像をリセット
    "src",
    "data:image/gif;base64,R0lGODlhAQABAGAAACH5BAEKAP8ALAAAAAABAAEAAAgEAP8FBAA7"
  );
  $(".stone2, .stone3, .stone4, .stone5").removeClass("hidden");
  $(".select_list dt:nth-child(5), .select_list dd:nth-child(6)").removeClass("hidden"); //1粒目の見出しとセレクトボックスを非表示
  $(".select_list dt:nth-child(7), .select_list dd:nth-child(8)").removeClass("hidden"); //2粒目の見出しとセレクトボックスを非表示
  $(".select_list dt:nth-child(9), .select_list dd:nth-child(10)").removeClass("hidden"); //3粒目の見出しとセレクトボックスを非表示
  $(".select_list dt:nth-child(11), .select_list dd:nth-child(12)").removeClass("hidden"); //4粒目の見出しとセレクトボックスを非表示
  $(".select_list dt:nth-child(13), .select_list dd:nth-child(14)").removeClass("hidden"); //5粒目の見出しとセレクトボックスを非表示

  //-----[商品によって選択できない石を非表示に]
  var stone_disabled = $(".select_item option:selected").data("stone_disabled");
  var stone_num = $(".select_item option:selected").data("stone_num");
  // var no = parseInt(e.currentTarget.selectedIndex);
  if (stone_disabled == true) {
    $(".select_stone option:nth-child(14)").prop("disabled", true);
    $(".select_stone option:nth-child(15)").prop("disabled", true);
    $(".select_stone option:nth-child(16)").prop("disabled", true);
    $(".select_stone option:nth-child(17)").prop("disabled", true);
  } else {
    $(".select_stone option:nth-child(14)").prop("disabled", false);
    $(".select_stone option:nth-child(15)").prop("disabled", false);
    $(".select_stone option:nth-child(16)").prop("disabled", false);
    $(".select_stone option:nth-child(17)").prop("disabled", false);
  }

  //-----[商品によって石の表示位置を調整]
  if (stone_num == 1) {
    $(".stone1").css({ margin: "-3% 0 0 -3%" });
    $(".stone2, .stone3, .stone4, .stone5").addClass("hidden");
    $(
      ".select_list dt:nth-child(7), .select_list dd:nth-child(8)"
    ).addClass("hidden");
    $(
      ".select_list dt:nth-child(9), .select_list dd:nth-child(10)"
    ).addClass("hidden");
    $(
      ".select_list dt:nth-child(11), .select_list dd:nth-child(12)"
    ).addClass("hidden");
    $(
      ".select_list dt:nth-child(13), .select_list dd:nth-child(14)"
    ).addClass("hidden");
  } else if (stone_num == 2) { //-----[2粒の時]
    $(".stone1").css({ margin: "-3% 0 0 -6%" });
    $(".stone2").css({ margin: "-3% 0 0 0%" });
    $(".stone3, .stone4, .stone5").addClass("hidden");
    $(
      ".select_list dt:nth-child(9), .select_list dd:nth-child(10)"
    ).addClass("hidden");
    $(
      ".select_list dt:nth-child(11), .select_list dd:nth-child(12)"
    ).addClass("hidden");
    $(
      ".select_list dt:nth-child(13), .select_list dd:nth-child(14)"
    ).addClass("hidden");
  } else if (stone_num == 3) { //-----[3粒の時]
    $(".stone1").css({ margin: "-3% 0 0 -8.5%" });
    $(".stone2").css({ margin: "-3% 0 0 -3%" });
    $(".stone3").css({ margin: "-3% 0 0 3%" });
    $(".stone4, .stone5").addClass("hidden");
    $(
      ".select_list dt:nth-child(11), .select_list dd:nth-child(12)"
    ).addClass("hidden");
    $(
      ".select_list dt:nth-child(13), .select_list dd:nth-child(14)"
    ).addClass("hidden");
  } else if (stone_num == 4) { //-----[4粒の時]
    $(".stone1").css({ margin: "-3% 0 0 -11.5%" });
    $(".stone2").css({ margin: "-3% 0 0 -6%" });
    $(".stone3").css({ margin: "-3% 0 0 -0.5%" });
    $(".stone4").css({ margin: "-3% 0 0 5%" });
    $(".stone5").addClass("hidden");
    $(
      ".select_list dt:nth-child(13), .select_list dd:nth-child(14)"
    ).addClass("hidden");
  } else if (stone_num == 5) { //-----[5粒の時]
    $(".stone1").css({ margin: "-3% 0 0 -15%" });
    $(".stone2").css({ margin: "-3% 0 0 -10%" });
    $(".stone3").css({ margin: "-3% 0 0 -4.4%" });
    $(".stone4").css({ margin: "-3% 0 0 1%" });
    $(".stone5").css({ margin: "-3% 0 0 7%" });
  }

  //-----[石の選択を解除]
  $(".select_stone1").val(0);
  $(".select_stone2").val(0);
  $(".select_stone3").val(0);
  $(".select_stone4").val(0);
  $(".select_stone5").val(0);
});

//------[金額やリンクの差し替え]
$(".simulator_container select").change(function (e) {
  var item_stone_pattern = $(".select_item option:selected").data("stone_pattern");
  var item_handle = $(".select_item option:selected").data("handle");

  // 金額
  var item_price = $(".select_item option:selected").data("price");
  var type_price = $(".select_type option:selected").data("price");
  var stone_price = 0;
  var stone_price1 = 0;
  var stone_price2 = 0;
  var stone_price3 = 0;
  var stone_price4 = 0;
  var stone_price5 = 0;
  
  if (item_stone_pattern == 1) {
    stone_price1 = $(".select_stone1 option:selected").data("price1");
    stone_price2 = $(".select_stone2 option:selected").data("price1");
    stone_price3 = $(".select_stone3 option:selected").data("price1");
    stone_price4 = $(".select_stone4 option:selected").data("price1");
    stone_price5 = $(".select_stone5 option:selected").data("price1");
    stone_price = stone_price1 + stone_price2 + stone_price3 + stone_price4 + stone_price5;
  } else if (item_stone_pattern == 2) {
    stone_price1 = $(".select_stone1 option:selected").data("price2");
    stone_price2 = $(".select_stone2 option:selected").data("price1");
    stone_price3 = $(".select_stone3 option:selected").data("price1");
    stone_price4 = $(".select_stone4 option:selected").data("price1");
    stone_price5 = $(".select_stone5 option:selected").data("price1");
    stone_price = stone_price1 + stone_price2 + stone_price3 + stone_price4 + stone_price5;
  } else if (item_stone_pattern == 3) {
    stone_price1 = $(".select_stone1 option:selected").data("price1");
    stone_price2 = $(".select_stone2 option:selected").data("price2");
    stone_price3 = $(".select_stone3 option:selected").data("price1");
    stone_price4 = $(".select_stone4 option:selected").data("price1");
    stone_price5 = $(".select_stone5 option:selected").data("price1");
    stone_price = stone_price1 + stone_price2 + stone_price3 + stone_price4 + stone_price5;
  } else if (item_stone_pattern == 4) {
    stone_price1 = $(".select_stone1 option:selected").data("price3");
    stone_price2 = $(".select_stone2 option:selected").data("price1");
    stone_price3 = $(".select_stone3 option:selected").data("price1");
    stone_price4 = $(".select_stone4 option:selected").data("price1");
    stone_price5 = $(".select_stone5 option:selected").data("price1");
    stone_price = stone_price1 + stone_price2 + stone_price3 + stone_price4 + stone_price5;
  }

  //------[金額を差し替え]
  var total_price = item_price + type_price + stone_price;
  total_price = String(total_price).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  $(".simulator_container .price .num").html(total_price);

  //------[ボタンのURLを差し替え]
  // パラメータ
  var param = null;
  var gold_param = 0;
  var stone1_param = 0;
  var stone2_param = 0;
  var stone3_param = 0;
  var stone4_param = 0;
  var stone5_param = 0;

  gold_param = $('.select_type').prop('selectedIndex');
  stone1_param = $('.select_stone1').prop('selectedIndex')-1;
  stone2_param = $('.select_stone2').prop('selectedIndex')-1;
  stone3_param = $('.select_stone3').prop('selectedIndex')-1;
  stone4_param = $('.select_stone4').prop('selectedIndex')-1;
  stone5_param = $('.select_stone5').prop('selectedIndex')-1;
  if(stone1_param == -1) { stone1_param = 0; }
  if(stone2_param == -1) { stone2_param = 0; }
  if(stone3_param == -1) { stone3_param = 0; }
  if(stone4_param == -1) { stone4_param = 0; }
  if(stone5_param == -1) { stone5_param = 0; }

  param = '?gold=' + gold_param + '&birthstone-1=' + stone1_param + '&birthstone-2=' + stone2_param + '&birthstone-3=' + stone3_param + '&birthstone-4=' + stone4_param + '&birthstone-5=' + stone5_param;

  $(".simulator_container .btn1 a").attr("href", '/products/' + item_handle + param);

  // 選択されてない項目がある場合にバリデーション
  var not_hidden = 0;
  var not_0 = 0;
  $(".simulator_container .select_container").each(function() {
    if ($(this).hasClass("hidden")) {
      // console.log('この要素にはhiddenクラスがついています');
    } else {
      not_hidden++;
      // console.log('この要素にはhiddenクラスがついていません');
      // ここで必要な処理を実行します
      var val = $(this).children('select').val();
      // console.log(val);
      if(val != 0) {
        not_0++;
        // console.log('選択されています');
      } else {
        // console.log('選択されています');
      }
    }
  });
  if(not_hidden === not_0) {
    // console.log('選択完了');
    if($('.collection_simulator_birthstone .price_container').hasClass('disabled')) {
      $('.collection_simulator_birthstone .price_container').removeClass('disabled');
      $('.collection_simulator_birthstone .price_container')
    }
  } else {
    // console.log('未選択項目有り');
    if(!$('.collection_simulator_birthstone .price_container').hasClass('disabled')) {
      $('.collection_simulator_birthstone .price_container').addClass('disabled');
    }
  }
});